var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params.value)?_c('feather-icon',{staticClass:"mb-2",attrs:{"icon":_vm.params.icon,"svgClasses":['h-8 w-8 text-danger']}}):_c('h3',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }